export default "__VITE_ASSET__CdJPSso2__"